import React from 'react';
import { AzureFieldsType } from './StorageTypeFields';
import { Typography } from '@mui/material';
import StorageIcon from '@mui/icons-material/Storage';
import FolderIcon from '@mui/icons-material/Folder';
import KeyIcon from '@mui/icons-material/VpnKey';

interface AzureFieldsProps extends AzureFieldsType {
  validationErrors: {
    storageAccount?: string;
    container?: string;
    accessKey?: string;
  };
  onChange: (field: string, value: string) => void;
  isEdit?: boolean;
}

const AzureBlobFields: React.FC<AzureFieldsProps> = ({
  storageAccount,
  container,
  accessKey,
  validationErrors,
  onChange,
  isEdit = false,
}) => {
  return (
    <div className="space-y-6">
      <div className="border-b border-gray-100 pb-6">
        <Typography variant="h6" className="text-gray-800 font-medium mb-4">
          Azure Blob Storage Configuration
        </Typography>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Storage Account <span className="text-red-500">*</span>
            </label>
            <div className="relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <StorageIcon className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                value={storageAccount}
                onChange={(e) => onChange('storageAccount', e.target.value)}
                placeholder="my-azure-storage"
                className={`pl-10 block w-full rounded-md border ${
                  validationErrors.storageAccount ? 'border-red-500' : 'border-gray-300'
                } bg-white py-2 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm`}
              />
            </div>
            {validationErrors.storageAccount && (
              <p className="mt-1 text-sm text-red-500">{validationErrors.storageAccount}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Container <span className="text-red-500">*</span>
            </label>
            <div className="relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FolderIcon className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                value={container}
                onChange={(e) => onChange('container', e.target.value)}
                placeholder="my-container"
                className={`pl-10 block w-full rounded-md border ${
                  validationErrors.container ? 'border-red-500' : 'border-gray-300'
                } bg-white py-2 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm`}
              />
            </div>
            {validationErrors.container && (
              <p className="mt-1 text-sm text-red-500">{validationErrors.container}</p>
            )}
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Access Key {!isEdit && <span className="text-red-500">*</span>}
              {isEdit && (
                <span className="text-xs text-gray-500 ml-1">
                  (leave blank to keep existing key)
                </span>
              )}
            </label>
            <div className="relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <KeyIcon className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="password"
                value={accessKey}
                onChange={(e) => onChange('accessKey', e.target.value)}
                placeholder="••••••••••••••••••••"
                className={`pl-10 block w-full rounded-md border ${
                  validationErrors.accessKey ? 'border-red-500' : 'border-gray-300'
                } bg-white py-2 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm`}
              />
            </div>
            {validationErrors.accessKey && (
              <p className="mt-1 text-sm text-red-500">{validationErrors.accessKey}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AzureBlobFields;
